// extracted by mini-css-extract-plugin
module.exports = {"Container":"message_Container__82jfL","Hide":"message_Hide__37YpF","Succes":"message_Succes__1sfBI","Fail":"message_Fail__2uRq7"};